import { Outlet } from 'react-router-dom';
import { useEffect, useMemo } from 'react';
import { applyBrandTheme, getRememberedBrand } from '../lib/brand';
import { COPYRIGHT } from './shell/legal';

/**
 * Minimal chrome for pages that must be reachable logged-out — the legal /
 * contact surfaces linked from the sign-in screen. Signed-in visitors get the
 * full app shell instead (see LegalShell in App.tsx). Wears the device's
 * remembered program brand like the other pre-auth screens.
 */
export default function PublicShell() {
  const brand = useMemo(() => getRememberedBrand(), []);
  useEffect(() => {
    applyBrandTheme(brand);
  }, [brand]);

  return (
    <div className="publicpage">
      <header className="publicpage-brand">
        {brand?.logoUrl ? (
          <img className="logo" src={brand.logoUrl} alt={brand.name ?? ''} />
        ) : (
          <span className="logo" aria-hidden>AA</span>
        )}
        <span>{brand?.name ?? 'Participant Portal'}</span>
      </header>
      <main>
        <Outlet />
      </main>
      <footer>{COPYRIGHT}</footer>
    </div>
  );
}
